import axios from 'axios';

export default class PrefilledListsClient {
  async getStates() {
    let url = `${process.env.VUE_APP_PREFILLED_LISTS_BASE_URL}/states`;
    return axios({url: url, method: 'get'});
  }
}
